import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { cn } from "@/lib/utils";
import { HandoverWizard } from "@/components/handover/HandoverWizard";
import { useIsMobile } from "@/hooks/use-mobile";

export default function HandoverPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const scopedPipelineId = searchParams.get("pipelineId")?.trim() || null;

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div
        id="handover-step-header"
        className={cn(
          "flex-shrink-0 bg-background border-b z-20",
          isMobile ? "min-h-0" : "h-[60px] px-4 py-4 relative overflow-hidden"
        )}
      />

      <div className="flex-1 min-w-0 overflow-hidden">
        <HandoverWizard
          dealId={id || null}
          scopedPipelineId={scopedPipelineId}
          onDealSelect={(dealId) => {
            const q = scopedPipelineId ? `?pipelineId=${encodeURIComponent(scopedPipelineId)}` : "";
            navigate(`/crm/handover/${dealId}${q}`);
          }}
        />
      </div>
    </div>
  );
}
